import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import DigitalSignature from './pages/digital-signature';
import TransactionDetails from './pages/transaction-details';
import DocumentManagement from './pages/document-management';
import StakeholderManagement from './pages/stakeholder-management';
import TransactionDashboard from './pages/transaction-dashboard';
import ReportsAnalytics from './pages/reports-analytics';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<DigitalSignature />} />
        <Route path="/digital-signature" element={<DigitalSignature />} />
        <Route path="/transaction-details" element={<TransactionDetails />} />
        <Route path="/document-management" element={<DocumentManagement />} />
        <Route path="/stakeholder-management" element={<StakeholderManagement />} />
        <Route path="/transaction-dashboard" element={<TransactionDashboard />} />
        <Route path="/reports-analytics" element={<ReportsAnalytics />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
